import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { AddPersonForm } from "@/features/appointments/components/add-person-form"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/people/new/"
)({
  staticData: { attention: "firm.people" },
  component: AddPersonPage,
})

function AddPersonPage() {
  const { firmId } = Route.useParams()
  const navigate = useNavigate()
  const back = () =>
    void navigate({
      from: "/$organisation",
      to: "/$organisation/firms/$firmId/people",
      params: { firmId },
    })

  return <AddPersonForm firmId={firmId} onFinished={back} onCancel={back} />
}
